import { render, staticRenderFns } from "./CommonListAccount.vue?vue&type=template&id=674e741f&scoped=true"
import script from "./CommonListAccount.vue?vue&type=script&lang=js"
export * from "./CommonListAccount.vue?vue&type=script&lang=js"
import style0 from "./CommonListAccount.vue?vue&type=style&index=0&id=674e741f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674e741f",
  null
  
)

export default component.exports